import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Navigation, Pagination, A11y, Autoplay, EffectFade, Mousewheel } from 'swiper/modules';

const options = {
	modules: [Navigation, A11y, Pagination, Autoplay, EffectFade, Mousewheel],
	speed: 1000,
	loop: false,
	a11y: {
		enabled: true,
		nextSlideMessage: window.wkScriptVars.next_slide,
		prevSlideMessage: window.wkScriptVars.previous_slide,
	},
};

const cardGrids = document.querySelectorAll('.card-grid');

if (cardGrids.length) {
	cardGrids.forEach(cardGrid => {
		const breakpoint = window.matchMedia('(min-width:768px)');
		let swiper = null;

		const breakpointChecker = function () {
			if (breakpoint.matches === true) {
				if (swiper !== undefined && swiper !== null) {
					swiper.destroy(true, true);
				}
			} else if (breakpoint.matches === false) {
				return enableSwiper();
			}
		};

		const enableSwiper = function () {
			swiper = new Swiper(cardGrid.querySelector('.card-grid__container'), {
				...options,
				slidesPerView: 1,
				spaceBetween: 32,
				mousewheel: {
					enabled: true,
					forceToAxis: true,
				},
				navigation: {
					nextEl: cardGrid.querySelector('.swiper-button-next'),
					prevEl: cardGrid.querySelector('.swiper-button-prev'),
				},
			});
		};

		breakpoint.addListener(breakpointChecker);

		breakpointChecker();
	});
}

const cardSliders = document.querySelectorAll('.card-slider');

if (cardSliders.length) {
	cardSliders.forEach(cardSlider => {
		new Swiper(cardSlider.querySelector('.card-slider__container'), {
			...options,
			slidesPerView: 1,
			spaceBetween: 32,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			slidesPerGroup: 1,
			navigation: {
				nextEl: cardSlider.querySelector('.swiper-button-next'),
				prevEl: cardSlider.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 64,
				},
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 96,
				},
			},
		});
	});
}

const MembershipSliders = document.querySelectorAll('.membership-slider');

if (MembershipSliders.length) {
	MembershipSliders.forEach(MembershipSlider => {
		const breakpoint = window.matchMedia('(min-width:768px)');
		let swiper = null;

		const breakpointChecker = function () {
			if (breakpoint.matches === true) {
				if (swiper !== undefined && swiper !== null) {
					swiper.destroy(true, true);
				}
			} else if (breakpoint.matches === false) {
				return enableSwiper();
			}
		};

		const enableSwiper = function () {
			swiper = new Swiper(MembershipSlider.querySelector('.membership-slider__container'), {
				...options,
				slidesPerView: 1,
				spaceBetween: 24,
				mousewheel: {
					enabled: true,
					forceToAxis: true,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			});
		};

		breakpoint.addListener(breakpointChecker);

		breakpointChecker();
	});
}

const relatedPostsSliders = document.querySelectorAll('.related-posts');

if (relatedPostsSliders.length) {
	relatedPostsSliders.forEach(relatedPostsSlider => {
		new Swiper(relatedPostsSlider.querySelector('.related-posts__container'), {
			...options,
			slidesPerView: 'auto',
			spaceBetween: 24,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			slidesPerGroup: 1,
			slidesPerGroupAuto: true,
			navigation: {
				nextEl: relatedPostsSlider.querySelector('.swiper-button-next'),
				prevEl: relatedPostsSlider.querySelector('.swiper-button-prev'),
			},
		});
	});
}

const PageHeaderSliders = document.querySelectorAll('.page-header-slider');

if (PageHeaderSliders.length) {
	PageHeaderSliders.forEach(PageHeaderSlider => {
		const swiper = new Swiper(PageHeaderSlider.querySelector('.page-header-slider__container'), {
			...options,
			slidesPerView: 1,
			spaceBetween: 0,
			effect: 'fade',
			speed: 500,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});

		swiper.on('slideChange', function () {
			const captionsDesktop = document.querySelectorAll('.page-header__captions--desktop .page-header__caption');

			captionsDesktop.forEach(caption => {
				if (caption.dataset.captionId === swiper.slides[swiper.realIndex].dataset.imageId) {
					const captionShow = document.querySelector(
						'.page-header__captions--desktop .page-header__caption.show'
					);
					if (captionShow) {
						captionShow.classList.remove('show');
					}
					caption.classList.add('show');
				}
			});

			const captionMobile = document.querySelectorAll('.page-header__captions--mobile .page-header__caption');

			captionMobile.forEach(caption => {
				if (caption.dataset.captionId === swiper.slides[swiper.realIndex].dataset.imageId) {
					const captionShow = document.querySelector(
						'.page-header__captions--mobile .page-header__caption.show'
					);
					if (captionShow) {
						captionShow.classList.remove('show');
					}
					caption.classList.add('show');
				}
			});
		});
	});
}

const historySlider = document.querySelector('.history');

if (historySlider) {
	new Swiper(historySlider.querySelector('.history__container'), {
		...options,
		speed: 2000,
		slidesPerView: 1,
		spaceBetween: 64,
		slidesPerGroup: 1,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			nextEl: historySlider.querySelector('.swiper-button-next'),
			prevEl: historySlider.querySelector('.swiper-button-prev'),
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
			1024: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			1440: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
		},
	});
}

const investementSliders = document.querySelectorAll('.investment-slider');

if (investementSliders.length) {
	investementSliders.forEach(investementSlider => {
		const swiper = new Swiper(investementSlider.querySelector('.investment-slider__container'), {
			...options,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1500,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			loop: true,

			navigation: {
				nextEl: investementSlider.querySelector('.swiper-button-next'),
				prevEl: investementSlider.querySelector('.swiper-button-prev'),
			},
		});

		let id = 0;
		const slides = investementSlider.querySelectorAll('.swiper-slide');

		slides.forEach(slide => {
			investementSlider.querySelector(`.investment-slider__caption-large[data-caption-id="${id}"]`).textContent =
				slide.dataset.captionLarge;
			investementSlider.querySelector(`.investment-slider__caption-small[data-caption-id="${id}"]`).textContent =
				slide.dataset.captionSmall;
			id = id + 1;
		});

		swiper.on('slideChange', function () {
			const current = investementSlider.querySelector('.investment-slider__current');
			if (swiper.realIndex + 1 > 9) {
				current.innerHTML = swiper.realIndex + 1;
			} else {
				current.innerHTML = '0' + (swiper.realIndex + 1);
			}

			const captionsLarge = investementSlider.querySelectorAll('.investment-slider__caption-large');

			captionsLarge.forEach(caption => {
				if (Number(caption.dataset.captionId) === swiper.realIndex) {
					const captionShow = investementSlider.querySelector('.investment-slider__caption-large.show');
					if (captionShow) {
						captionShow.classList.remove('show');
					}
					caption.classList.add('show');
				}
			});

			const captionsSmall = investementSlider.querySelectorAll('.investment-slider__caption-small');

			captionsSmall.forEach(caption => {
				if (Number(caption.dataset.captionId) === swiper.realIndex) {
					const captionShow = investementSlider.querySelector('.investment-slider__caption-small.show');
					if (captionShow) {
						captionShow.classList.remove('show');
					}
					caption.classList.add('show');
				}
			});
		});
	});
}
